import React from 'react';
import { PreviewPage } from 'shared';

export default function DashboardPreview() {
  return <PreviewPage />;
}
